export const mtPercentiles = [
  { percentile: 0.0, z_score: -3.560961487 },
  { percentile: 0.01, z_score: -0.8951949517 },
  { percentile: 0.02, z_score: -0.7983532068 },
  { percentile: 0.03, z_score: -0.7390162063 },
  { percentile: 0.04, z_score: -0.6957948315 },
  { percentile: 0.05, z_score: -0.6612254054 },
  { percentile: 0.06, z_score: -0.6323615344 },
  { percentile: 0.07, z_score: -0.6075247179 },
  { percentile: 0.08, z_score: -0.5853025243 },
  { percentile: 0.09, z_score: -0.5652555891 },
  { percentile: 0.1, z_score: -0.5468927741 },
  { percentile: 0.11, z_score: -0.5299798221 },
  { percentile: 0.12, z_score: -0.5140674426 },
  { percentile: 0.13, z_score: -0.4991832209 },
  { percentile: 0.14, z_score: -0.4850637979 },
  { percentile: 0.15, z_score: -0.4717156356 },
  { percentile: 0.16, z_score: -0.4588311269 },
  { percentile: 0.17, z_score: -0.4465696216 },
  { percentile: 0.18, z_score: -0.434623381 },
  { percentile: 0.19, z_score: -0.42303013 },
  { percentile: 0.2, z_score: -0.4116541976 },
  { percentile: 0.21, z_score: -0.4005917101 },
  { percentile: 0.22, z_score: -0.3897143915 },
  { percentile: 0.23, z_score: -0.379012258 },
  { percentile: 0.24, z_score: -0.3684515255 },
  { percentile: 0.25, z_score: -0.3581155792 },
  { percentile: 0.26, z_score: -0.3478580358 },
  { percentile: 0.27, z_score: -0.3376513844 },
  { percentile: 0.28, z_score: -0.3274030181 },
  { percentile: 0.29, z_score: -0.3173901798 },
  { percentile: 0.3, z_score: -0.3073180319 },
  { percentile: 0.31, z_score: -0.2972457885 },
  { percentile: 0.32, z_score: -0.2873068512 },
  { percentile: 0.33, z_score: -0.2772102298 },
  { percentile: 0.34, z_score: -0.2671573657 },
  { percentile: 0.35, z_score: -0.2570538992 },
  { percentile: 0.36, z_score: -0.2468553621 },
  { percentile: 0.37, z_score: -0.2366965789 },
  { percentile: 0.38, z_score: -0.2265226956 },
  { percentile: 0.39, z_score: -0.2160918954 },
  { percentile: 0.4, z_score: -0.205857357 },
  { percentile: 0.41, z_score: -0.1953594423 },
  { percentile: 0.42, z_score: -0.184834494 },
  { percentile: 0.43, z_score: -0.1743346411 },
  { percentile: 0.44, z_score: -0.163817938 },
  { percentile: 0.45, z_score: -0.1530729363 },
  { percentile: 0.46, z_score: -0.142161668 },
  { percentile: 0.47, z_score: -0.1312841567 },
  { percentile: 0.48, z_score: -0.1202370795 },
  { percentile: 0.49, z_score: -0.1090228878 },
  { percentile: 0.5, z_score: -0.09774907965 },
  { percentile: 0.51, z_score: -0.08634656597 },
  { percentile: 0.52, z_score: -0.07462113381 },
  { percentile: 0.53, z_score: -0.06277123121 },
  { percentile: 0.54, z_score: -0.05086094867 },
  { percentile: 0.55, z_score: -0.03876801592 },
  { percentile: 0.56, z_score: -0.02650570119 },
  { percentile: 0.57, z_score: -0.01404300307 },
  { percentile: 0.58, z_score: -0.001490681648 },
  { percentile: 0.59, z_score: 0.01122376603 },
  { percentile: 0.6, z_score: 0.02430384866 },
  { percentile: 0.61, z_score: 0.03752894974 },
  { percentile: 0.62, z_score: 0.05099075598 },
  { percentile: 0.63, z_score: 0.06458317848 },
  { percentile: 0.64, z_score: 0.07851383942 },
  { percentile: 0.65, z_score: 0.09287168886 },
  { percentile: 0.66, z_score: 0.1074744808 },
  { percentile: 0.67, z_score: 0.1225232973 },
  { percentile: 0.68, z_score: 0.1378588269 },
  { percentile: 0.69, z_score: 0.1536800975 },
  { percentile: 0.7, z_score: 0.1699783562 },
  { percentile: 0.71, z_score: 0.1867990979 },
  { percentile: 0.72, z_score: 0.2040277696 },
  { percentile: 0.73, z_score: 0.2216672561 },
  { percentile: 0.74, z_score: 0.2401484297 },
  { percentile: 0.75, z_score: 0.2591261954 },
  { percentile: 0.76, z_score: 0.2790382108 },
  { percentile: 0.77, z_score: 0.2993532524 },
  { percentile: 0.78, z_score: 0.320325931 },
  { percentile: 0.79, z_score: 0.3425014884 },
  { percentile: 0.8, z_score: 0.3653581546 },
  { percentile: 0.81, z_score: 0.3885426248 },
  { percentile: 0.82, z_score: 0.413148539 },
  { percentile: 0.83, z_score: 0.4386698959 },
  { percentile: 0.84, z_score: 0.4650364111 },
  { percentile: 0.85, z_score: 0.4925188953 },
  { percentile: 0.86, z_score: 0.5210561786 },
  { percentile: 0.87, z_score: 0.5513178014 },
  { percentile: 0.88, z_score: 0.5833651223 },
  { percentile: 0.89, z_score: 0.6173120981 },
  { percentile: 0.9, z_score: 0.653822993 },
  { percentile: 0.91, z_score: 0.6928814164 },
  { percentile: 0.92, z_score: 0.7350658176 },
  { percentile: 0.93, z_score: 0.7815040182 },
  { percentile: 0.94, z_score: 0.8333145031 },
  { percentile: 0.95, z_score: 0.8934496213 },
  { percentile: 0.96, z_score: 0.9658946808 },
  { percentile: 0.97, z_score: 1.06607597 },
  { percentile: 0.98, z_score: 1.232448281 },
  { percentile: 0.99, z_score: 1.627355195 },
  { percentile: 1.0, z_score: 31.384884162 },
];
